import { ProductsListItemResponseDto } from '@/apis/rest/generated/types'
import styles from '@/components/domains/home/new/new-arrival-product-list.module.css'
import { NewProductCard } from '@/components/domains/products/new-product-card/new-product-card'
import { PRODUCT_CARD_SIZES } from '@/components/domains/products/new-product-card/new-product-card.type'
import { useHomeNewProductTracker } from '@/containers/event-tracker/home-new-product.tracker'
import { useHomeSectionProductTracker } from '@/containers/event-tracker/home-section-product.tracker'
import { ProductTypeDefinedByFrontend } from '@/types/product-type-defined-by.frontend'
import { HomeSectionLimit, sliceArray } from '@/utils/home-section/utilHomeSection'
import { transformProductTypeDefinedByFrontend } from '@/utils/product/product-card.util'

type NewArrivalProductListProps = {
  list: ProductsListItemResponseDto[]
  sectionName?: string
  sectionIndex: number
}

export const NewArrivalProductList = ({ list, sectionName, sectionIndex }: NewArrivalProductListProps) => {
  const { trackClickHomeNewProductEvent } = useHomeNewProductTracker()
  const { trackClickHomeSectionProductEvent } = useHomeSectionProductTracker()

  const handleClickProductCard = (product: ProductTypeDefinedByFrontend) => {
    trackClickHomeSectionProductEvent({
      product,
      sectionName: sectionName || '',
      sectionIndex,
    })
    trackClickHomeNewProductEvent({ product })
  }

  return (
    <div className={styles.listContainer}>
      {sliceArray(HomeSectionLimit, list).map((product) => {
        const productData = transformProductTypeDefinedByFrontend(product)
        return (
          <div className={styles.productCard} key={product.id}>
            <NewProductCard
              product={productData}
              size={PRODUCT_CARD_SIZES.lg}
              onClickProductCard={() => handleClickProductCard(productData)}
            />
          </div>
        )
      })}
    </div>
  )
}
